import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonStyle } from 'src/aero/aero-button/aero-button.component';

@Component({
  selector: 'bulb-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
  standalone: false,
})
export class GenericDialogComponent implements OnInit {
  public iconKey: string;

  public title: string;

  public description: string;

  public dismissLabel: string;

  public confirmLabel: string;

  public cancelButtonStyle: ButtonStyle = ButtonStyle.GREY;

  constructor(
    public modalDialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) { }

  ngOnInit() {
    this.iconKey = this.config.data.iconKey;
    this.title = this.config.data.title;
    this.description = this.config.data.description;
    this.dismissLabel = this.config.data.dismissLabel;
    this.confirmLabel = this.config.data.confirmLabel;
  }

  public confirm(): void {
    this.modalDialog.close(true);
  }

  public cancel(): void {
    this.modalDialog.close(false);
  }

  public dismiss(): void {
    this.modalDialog.close();
  }
}
